module.exports = __webpack_public_path__ + "static/media/Klavika-Regular.2b4abc38.woff";